<template>
  <div class="page_container">
    <div class="page_header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/user_management' }">用户管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-card class="page_card">
      <div class="tab_list">
        <ul>
          <li @click="handleClickTab(1)" :class="activeTab == 1 ? 'active' : ''">企业内用户</li>
          <li @click="handleClickTab(2)"  :class="activeTab == 2 ? 'active' : ''">已移除用户</li>
        </ul>
        <el-button v-if="activeTab == 1" type="primary" size="small"  @click="handleClickInvite()">邀请成员</el-button>
      </div>

      <template v-if="activeTab == 1">
        <el-table ref="table1" :data="tableData" style="width: 100%" :height="tableHeight">
          <el-table-column prop="date" align="center" label="姓名" min-width="120"></el-table-column>
          <el-table-column prop="date" align="center" label="加入渠道" min-width="120"></el-table-column>
          <el-table-column prop="date" align="center" label="加入时间" min-width="120"></el-table-column>
          <el-table-column prop="date" align="center" label="邮箱" min-width="120"></el-table-column>
          <el-table-column prop="date" align="center" label="手机号" min-width="120"></el-table-column>
          <el-table-column prop="date" align="center" label="操作" width="120" fixed="right">
            <template slot-scope="{row}">
              <el-button size="mini" type="text" @click="handleClickRemove(row)">从企业中移除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-else>
        <el-table ref="table2" :data="tableData" style="width: 100%" :height="tableHeight">
          <el-table-column prop="date" align="center" label="姓名" width="80"></el-table-column>
          <el-table-column prop="date" align="center" label="移除人" min-width="120"></el-table-column>
          <el-table-column prop="date" align="center" label="移除时间" min-width="120"></el-table-column>
          <el-table-column prop="date" align="center" label="邮箱" min-width="120"></el-table-column>
          <el-table-column prop="date" align="center" label="手机号" min-width="120"></el-table-column>
        </el-table>
      </template>


      <el-pagination background
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="pagination.pageNum"
                     :page-sizes="pagination.pageSizes"
                     :page-size="pagination.pageSize"
                     :layout="pagination.layout"
                     :total="pagination.total">
      </el-pagination>


    </el-card>
    <inviteMembers :inviteVisible.sync="inviteVisible" v-if="inviteVisible"  @success="getTableData()"/>
  </div>
</template>

<script>
import {} from '@/api/api'
import {getTableHeight} from '@/utils'
import {pagination} from '@/mixins'
import {mapState} from "vuex";
import inviteMembers from './invite_members.vue'
export default {
  name: 'user_management',

  data() {
    return {
      loading: false,
      tableHeight: '',
      activeTab:1,
      inviteVisible:false,
      tableData: [{}]
    }
  },
  components: {
    inviteMembers,
  },
  mixins: [pagination],
  created() {
    //将计算的table高度赋值给table
    this.tableHeight = getTableHeight(260)
  },
  mounted() {

    //窗口缩放时动态修改table的高度
    window.onresize = () => {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer)
      }
      //开启定时器，节流函数
      this.resizeTimer = setTimeout(() => {
        //将计算的table高度赋值给table
        this.tableHeight = getTableHeight(260)
        //清除定时器
        this.resizeTimer = null
      }, 100)
    }
  },
  computed: {
    ...mapState(['webUserInfo']),
  },
  methods: {

    handleClickTab(value){
      this.activeTab = value
      this.$nextTick(()=>{
        if(this.$refs.table1){ this.$refs.table1.doLayout()}
        if(this.$refs.table2){ this.$refs.table2.doLayout()}
      })
    },
    // 邀请
    handleClickInvite(){
      this.inviteVisible = true
    },
    // 移除
    handleClickRemove(){
      this.$confirm('是否确认将用户********移除本企业？', '提示', {
        confirmButtonText: '确认移除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

      }).catch(() => {

      });
    },
    getTableData() {

    },


    handleSizeChange(val) {
      this.pagination.pageNum = 1
      this.pagination.pageSize = val
      this.getTableData()
    },
    handleCurrentChange(val) {
      this.pagination.pageNum = val
      this.getTableData()
    },

  },
  watch: {},
}
</script>

<style scoped lang="scss">
.kx {
  width: 100%;
  height: 30px;
}

.chart {
  height: 540px
}
::v-deep .cell{
  line-height: 28px;
  min-height: 28px;
}
.page_container .page_card {
  overflow-y: scroll;
  padding-bottom: 20px;

  .tab_list{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    ul{
      display: flex;
      li{
        height: 34px;
        line-height: 22px;
        margin-right: 24px;
        color: rgba(102, 102, 102, 1);
        font-size: 16px;
        border-bottom: 1px solid #fff;
        box-sizing: border-box;
        cursor: pointer;
        &.active{
          color: rgba(25, 144, 255, 1);
          border-bottom: 1px solid rgba(25, 144, 255, 1);
        }
      }
    }
  }
}

</style>
